// FiltersByClient.jsx

import React, { useMemo } from "react";

import FilterDropdown, { transformArrToOptions } from "./FiltersDropdown";

const FiltersByClient = ({
    height = "auto",

    hotelsList,
    setSelectedHotels,
    handleSelectedHotels,
    selectedHotels = [],

    currencies = {},
    setSelectedCurrencies,
    selectedCurrencies = [],
    handleSelectedCurrencies,

    accountManagers = {},
    setSelectedAccountManagers,
    selectedAccountManagers = [],
    handleSelectedAccountManagers,
}) => {
    const hotelsOptions = useMemo(
        () => (hotelsList?.length ? [...hotelsList].sort() : []),
        [hotelsList]
    );

    const currenciesOptions = useMemo(() => {
        if (!currencies || typeof currencies !== "object") return {};

        return Object.fromEntries(
            Object.entries(currencies).map(([code, symbol]) => [
                code,
                `${code} (${symbol})`,
            ])
        );
    }, [currencies]);

    const accountManagersOptions = useMemo(() => {
        if (!accountManagers || typeof accountManagers !== "object") return {};
        return Object.fromEntries(
            Object.keys(accountManagers).map((am_id) => [
                am_id,
                accountManagers[am_id].name,
            ])
        );
    }, [accountManagers]);

    const activeFilters = useMemo(
        () => ({
            Hotels: selectedHotels,
            Currencies: selectedCurrencies,
            AccountManagers: selectedAccountManagers,
        }),
        [selectedHotels, selectedCurrencies, selectedAccountManagers]
    );

    const propagate = ({
        Hotels = [],
        Currencies = [],
        AccountManagers = [],
    }) => {
        if (Hotels !== selectedHotels) {
            setSelectedHotels(Hotels);
            handleSelectedHotels?.(Hotels);
        }

        if (Currencies !== selectedCurrencies) {
            setSelectedCurrencies(Currencies);
            handleSelectedCurrencies?.(Currencies);
        }

        if (AccountManagers !== selectedAccountManagers) {
            setSelectedAccountManagers(AccountManagers);
            handleSelectedAccountManagers?.(AccountManagers);
        }
    };

    return (
        <>
            <FilterDropdown
                title="Filters"
                buttonProps={{ sx: { height } }}
                activeFilters={activeFilters}
                setActiveFilters={propagate}
                allowExclusion={false}
                filters={{
                    Hotels: {
                        label: "Hotels",
                        options: transformArrToOptions(hotelsOptions),
                    },
                    Currencies: {
                        label: "Currencies",
                        options: currenciesOptions,
                    },
                    AccountManagers: {
                        label: "Account Manager",
                        options: accountManagersOptions,
                    },
                }}
            />
        </>
    );
};

export default FiltersByClient;
